import React from 'react';
import LinkedPoliciesList from '../features/dashboard/components/LinkedPoliciesList';
import AdditionalInterestsList from '../features/dashboard/components/AdditionalInterestsList';
import type { AdditionalInterestItem, PolicyItem } from '../features/dashboard/types/dashboard';
import type { ApiAdditionalInterest } from '../features/dashboard/hooks/useAdditionalInterests';
import '../styles/layout.css';

export type RightPanelProps = {
  linkedPolicies: PolicyItem[];
  additionalInterests: AdditionalInterestItem[];
  rawAdditionalInterests?: ApiAdditionalInterest[];
  insuredId?: string;
  isAdditionalInterestsLoading?: boolean;
  onRefetchAdditionalInterests?: () => void;
  insuredDatabaseId?: string;
  insuredEmail?: string;
  insuredFirstName?: string;
  insuredLastName?: string;
  insuredCommercialName?: string;
  aiFirst?: number;
  aiRows?: number;
  aiTotalCount?: number;
  onAiPageChange?: (first: number) => void;
};

export default function RightPanel({
  linkedPolicies,
  additionalInterests,
  rawAdditionalInterests,
  insuredId,
  isAdditionalInterestsLoading,
  onRefetchAdditionalInterests,
  insuredDatabaseId,
  insuredEmail,
  insuredFirstName,
  insuredLastName,
  insuredCommercialName,
  aiFirst,
  aiRows,
  aiTotalCount,
  onAiPageChange,
}: RightPanelProps) {
  return (
    <aside className="app-rightpanel" aria-label="Linked policies and additional interests">
      <div className="app-rightpanel__stack">
        <LinkedPoliciesList
          items={linkedPolicies}
          insuredId={insuredId}
          insuredName={insuredCommercialName || [insuredFirstName, insuredLastName].filter(Boolean).join(' ')}
        />
        <AdditionalInterestsList
          items={additionalInterests}
          rawItems={rawAdditionalInterests}
          isLoading={isAdditionalInterestsLoading}
          onRefetch={onRefetchAdditionalInterests}
          insuredDatabaseId={insuredDatabaseId}
          insuredEmail={insuredEmail}
          insuredFirstName={insuredFirstName}
          insuredLastName={insuredLastName}
          insuredCommercialName={insuredCommercialName}
          first={aiFirst}
          rows={aiRows}
          totalCount={aiTotalCount}
          onPageChange={onAiPageChange}
        />
      </div>
    </aside>
  );
}
